/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $GenericError = {
  properties: {
    code: {
      type: 'string',
      isRequired: true,
    },
    message: {
      type: 'string',
      isRequired: true,
    },
  },
} as const;
